<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16UVTh7/tc-custom/9780718023676.jpg?1703853945425" alt="This image is the cover for the book Building Faith, Amish Home Novellas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Building Faith, Amish Home Novellas
      </h1>
      <p class="bookDescription body article font2">
        <p>Faith Miller knows that carpentry is an unlikely hobby for a young Amish woman, but she loves the work and it keeps the memory of her grandfather alive. So when her cousin asks Faith to build the cabinets in her new home, Faith is only too happy to take on the job, even if it is the most ambitious project she has ever taken on. The only catch is that she has to work with her ex-fiance, Silas. As they work to build Martha’s kitchen, can they put the past behind them and start to build faith in one another again?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathleen Fuller
      </h2>
      
      <p class="authorDescription body article"><P>With over two million copies sold, Kathleen Fuller is the&#160;<I>USA TODAY</I>&#160;bestselling author of several bestselling novels, including the Hearts of Middlefield novels, the Middlefield Family novels, the Amish of Birch Creek series, and the Amish Letters series as well as a middle-grade Amish series, the Mysteries of Middlefield. Visit her online at KathleenFuller.com; Instagram: @kf_booksandhooks; Facebook: @WriterKathleenFuller; Twitter: @TheKatJam.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?83048088